
function kycManagement() {

  let KycManagement = [
    {
      name: "KYC Management",
      icon: "KYC Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "kycmanagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/kyc-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };
  const kycConfiguration = () => {
    const profileArr = [
      {
        path: "/index/kyc-configuration",
        name: "Kyc Configuration",
        icon: "Kyc Configuration",
        logoName: "kyc configration1",
        flag: "KYC CONFIGURATION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const kycReport = () => {
    const mybanksArr = [
      {
        path: "/index/kyc-report",
        name: "KYC Report",
        icon: "KYC Report",
        logoName: "kyc report",
        flag: "KYC REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const kybReport = () => {
    const mycardsArr = [
      {
        path: "/index/kyb-report",
        name: "KYB Report",
        icon: "KYB Report",
        logoName: "kyb report1",
        flag: "KYB REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = kycConfiguration();
  let c = kycReport();
  let d = kybReport();
  KycManagement[0].items = [...a, ...b, ...c, ...d];

  return KycManagement;
}

export default kycManagement;
